import { Checkbox, FormControl, FormControlLabel, FormGroup, InputAdornment, InputLabel, MenuItem, Select } from "@mui/material";
import { Autocomplete } from "@mui/material";
import { Field, Form, Formik } from "formik";
import { FormikTextField } from '../../CommonComponents/FormField.js';
import React, { Component } from "react";
import { Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import withRouter from "../../withRouter.js";
import { currentTenant, userid } from "../../Common/Credentials.js";
import Footer from "../../Component/Footer.js";
import Header from "../../Component/Header.js";
import Menu from "../../Component/Menu.js";
import MasterService from "../MasterService.js";
import SupplierService from "./SupplierService.js";
import { accounts } from "../../Common/Products.js";
import NewLedgerService from "../../Accounts/Ledgers/NewLedgerService.js";
import SubHeadsService from "../../Accounts/Subhead/SubHeadsService.js";
import SettingsServices from "../../Settings/SettingsServices.js";
import Breadcrumb from "../../NewUI/NewComponents/Breadcrumb.jsx";
import AutoCompeteField from "../../NewUI/NewComponents/AutoCompeteField.jsx";
import SelectField from "../../NewUI/NewComponents/SelectField.jsx";
import PhoneInput from "../../Component/PhoneInput.jsx";
import TextfieldComponent from "../../Component/TextfieldComponent.jsx";

class NewSupplier extends Component {
  constructor(props) {
    super(props);

    const { name } = this.props.location.state;
    this.state = {
      // type: 'password',
      name: name,
      id: "",
      StateId: "",
      state: '',
      CountryId: "",
      country: '',
      city: '',
      CityId: "",
      message: "",
      createledger: false,
      countryprefix: ["91 IND", "93 AFG"],

      CountryData: [],
      StateData: [],
      CityData: [],
      statecode: '',
      item: [],
      customsupplierid: '',
      companyname: "",
      contactname: "",
      prefix: "",
      contactnumber: "",
      email: "",
      address: "",
      address2: "",
      pan: "",
      gstin: "",
      vat: '',
      zip: "",
      error: "",
      countries: "",
      states: "",
      cities: "",
      alternatephonecode: "",
      alternatenumber: '',
      phonecode: '',
      loader: false,
      currencylist: [],
      currency: '',
      currencyid: '',
      taxtype: '',
      TaxtypeData: [],
      masterLedgers: [],
      ledGroups: [],
      ledgerid: null,
      type: "",
      types: ["Domestic", "International"],
      amount: 0,
      registrationtype: 'Unregistered',
      Registrationtypes: [{ "id": 1, "type": "Registered" }, { "id": 2, "type": "Unregistered" }, { "id": 3, "type": "Composition" }, { "id": 4, "type": "SEZ (Special economic zone)" }]
      //[{0:"Registered"},{1:"Unregistered"},{2:"Composition"},{3:"SEZ (Special economic zone)"}]
    };
    this.onSubmit = this.onSubmit.bind(this);
    //  this.handleChange=this.handleChange.bind(this)
    this.validate = this.validate.bind(this);
    // this.ChangeteState = this.ChangeteState.bind(this);
    // this.ChangeState = this.ChangeState.bind(this);
  }


  onSubmit(values) {
    this.setState({ loader: true });
    let newSupplier = {
      companyname: this.state.companyname,
      contactname: this.state.contactname,
      contactnumber: this.state.contactnumber.replace(/[^0-9]+/ig, ""),
      email: this.state.email,
      address: this.state.address,
      address2: this.state.address2,
      pan: this.state.pan,
      gstin: this.state.gstin,
      zip: this.state.zip,
      country: this.state.CountryId,
      countryname: this.state.country,
      state: this.state.StateId,
      statename: this.state.state,
      city: this.state.CityId,
      cityname: this.state.city,
      statecode: this.state.statecode,
      tenantId: currentTenant,
      createdby: userid,
      alternatenumber: this.state.alternatenumber === undefined || this.state.alternatenumber === null ? '' : this.state.alternatenumber.replace(/[^0-9]+/ig, ""),
      currency: this.state.currency,
      phonecode: this.state.phonecode,
      taxtype: this.state.taxtype,
      registrationtype: this.state.registrationtype
    };

    let updateSupplier = {
      id: this.state.id,
      companyname: this.state.companyname,
      contactname: this.state.contactname,
      contactnumber: this.state.contactnumber.replace(/[^0-9]+/ig, ""),
      email: this.state.email,
      address: this.state.address,
      address2: this.state.address2,
      pan: this.state.pan,
      gstin: this.state.gstin,
      zip: this.state.zip,
      country: this.state.CountryId,
      countryname: this.state.country,
      state: this.state.StateId,
      statename: this.state.state,
      city: this.state.CityId,
      cityname: this.state.city,
      statecode: this.state.statecode,
      updatedby: userid,
      alternatenumber: this.state.alternatenumber === undefined || this.state.alternatenumber === null ? '' : this.state.alternatenumber.replace(/[^0-9]+/ig, ""),
      customsupplierid: this.state.customsupplierid,
      currency: this.state.currency,
      phonecode: this.state.phonecode,
      taxtype: this.state.taxtype,
      ledgerid: this.state.ledgerid,
      registrationtype: this.state.registrationtype

    };
    if (this.state.id === "") {
      SupplierService.createSupplier(newSupplier)
        .then((res) => {
          // this.props.navigate({ pathname: "/suppliers"},{state:{message: values.companyname + "   : Created Successfully"}
          //   })

          if (this.state.createledger) {
            let data = this.state.masterLedgers.find(e => e.mastertype === "Supplier" && e.type === this.state.type)

            if (data) {
              let newpledgerreq = {
                name: values.companyname,
                createdBy: userid,
                amount: this.state.amount,
                pledger: res.data.id,
                ledgroupid: data.ledgergroup.id,
                ledgroupname: data.ledgergroup.name,
                eledger: null,
                expenseid: null,
                expensename: null,
                assledid: null,
                assledname: null,
                subhead: data.subhead,
                tenantId: currentTenant,
                pan: "",
                date: null,
                receipt: 0,
                refund: 0,
                notetype: 0,
                taxtype: 0,
                partyledtype: 0,
              }

              NewLedgerService.createPartyLedger(newpledgerreq).then(() => {
                this.props.navigate({ pathname: "/suppliers" }, { state: { message: values.companyname + "   : Created Successfully" } })
              }).catch(() => {
                this.props.navigate({ pathname: "/suppliers" }, { state: { message: values.companyname + "   : Created Successfully" } })
              })
            } else {
              this.props.navigate({ pathname: "/suppliers" }, { state: { message: values.companyname + "   : Created Successfully" } })
            }
          } else {
            this.props.navigate({ pathname: "/suppliers" }, { state: { message: values.companyname + "   : Created Successfully" } })
          }
        })
        .catch((error) => {
          if (error.response.data.error === "Unauthorized") {
            alert("Your Session is Lost: Please login Back to resume");
            this.props.navigate(`/`);
          }
          this.setState({
            error: error.response.data.message,
            loader: false,
          })
        }
        );
    } else {
      SupplierService.updateSupplier(updateSupplier).then(() => {
        // this.props.navigate({ pathname: "/suppliers"},{state:{message: values.companyname + "   : Updated Successfully"}

        if (this.state.createledger) {
          let data = this.state.masterLedgers.find(e => e.mastertype === "Supplier" && e.type === this.state.type)

          if (data) {
            let newpledgerreq = {
              name: values.companyname,
              createdBy: userid,
              amount: this.state.amount,
              pledger: res.data.id,
              ledgroupid: data.ledgergroup.id,
              ledgroupname: data.ledgergroup.name,
              eledger: null,
              expenseid: null,
              expensename: null,
              assledid: null,
              assledname: null,
              subhead: data.subhead,
              tenantId: currentTenant,
              pan: "",
              date: null,
              receipt: 0,
              refund: 0,
              notetype: 0,
              taxtype: 0,
              partyledtype: 0,
            }

            NewLedgerService.createPartyLedger(newpledgerreq).then(() => {
              this.props.navigate({ pathname: "/suppliers" }, { state: { message: values.companyname + "   : Updated Successfully" } })
            }).catch(() => {
              this.props.navigate({ pathname: "/suppliers" }, { state: { message: values.companyname + "   : Updated Successfully" } })
            })
          } else {
            this.props.navigate({ pathname: "/suppliers" }, { state: { message: values.companyname + "   : Updated Successfully" } })
          }
        } else {
          this.props.navigate({ pathname: "/suppliers" }, { state: { message: values.companyname + "   : Updated Successfully" } })
        }
      })
        .catch((e) => {
          this.setState({ loader: false })
          if (e.response.data.error === "Unauthorized") {
            alert("Your Session is Lost: Please login Back to resume");
            this.props.navigate(`/`);
          }
        })
    }
  }

  handleCurrency = (value, values) => {
    if (values !== '' && typeof values === 'object' && values !== null) {
      this.setState({ currencyid: values.id, currency: values.currency })
    } else {
      this.setState({ currencyid: '', currency: '' })
    }
  }

  handleTaxTypeChange = (e) => {
    this.setState({ taxtype: e.target.value })
  }

  handleRegistrationTypeChange = (e) => {
    this.setState({ registrationtype: e.target.value });
  }

  fetchLedgerGroups = () => {
    SubHeadsService.getLedGroups(currentTenant).then((res) => {
      this.setState({ ledGroups: res.data })
      this.fetch(res.data)
    })
  }
  fetch = (data) => {
    SettingsServices.getAllMasterLedgerMapping(currentTenant).then((res) => {
      let masterdata = []
      masterdata = res.data.map(e => { return { ...e, ledgergroup: data.find(l => l.id === e.ledgergroup) } })
      this.setState({ masterLedgers: [...masterdata] })
    })
  }


  componentDidMount() {
    if (userid === undefined) {
      window.confirm("Your Session is Lost: Please login Back to resume");
      this.props.navigate(`/`);
    }

    SupplierService.getCountries().then((response) =>
      this.setState({
        CountryData: response.data,
      })
    )
      .catch((e) => {
        if (e.response.data.error === "Unauthorized") {
          alert("Your Session is Lost: Please login Back to resume");
          this.props.navigate(`/`);
        }
      })

    MasterService.GetAllCurrency().then((response) => {
      this.setState({ currencylist: response.data })
    });
    MasterService.getTaxtypes().then((response) =>
      this.setState({
        TaxtypeData: response.data,
      })
    );

    this.fetchLedgerGroups()

    const { id } = this.props.location.state;

    //let {id} = this.props.location.state
    if (id < 1) {
      //  this.setState({id:id})
      return;
    }
    SupplierService.retriveSupplier(id).then((response) =>
      this.setState({
        id: response.data.id,
        companyname: response.data.companyname,
        contactname: response.data.contactname,
        prefix: response.data.prefix,
        alternatenumber: response.data.alternatenumber,
        contactnumber: response.data.contactnumber,
        email: response.data.email,
        address: response.data.address,
        address2: response.data.address2,
        pan: response.data.pan,
        gstin: response.data.gstin,
        zip: response.data.zip,
        country: response.data.countryname,
        state: response.data.statename,
        city: response.data.cityname,
        CountryId: response.data.country,
        StateId: response.data.state,
        CityId: response.data.city,
        statecode: response.data.statecode,
        customsupplierid: response.data.customsupplierid,
        currency: response.data.currency,
        phonecode: response.data.phonecode,
        taxtype: response.data.taxtype,
        registrationtype: response.data.registrationtype,
        ledgerid: response.data.ledgerid
      })
    );
  }

  ChangeCountry = (value, values) => {
    if (values !== '' && typeof values === 'object' && values !== null) {
      this.setState({ country: values.name, CountryId: values.id, phonecode: values.phonecode, state: '', StateId: '', city: '', CityId: '', CityData: [], statecode: '' });
      SupplierService.getStates(values.id).then((response) => {
        this.setState({
          StateData: response.data,
        });
      });
    } else {
      this.setState({
        country: '', CountryId: '', state: '', StateData: [], CityData: [], StateId: '', city: '', CityId: '', statecode: ''
      })
    }
  };
  ChangeState = (value, values) => {
    if (values !== '' && typeof values === 'object' && values !== null) {
      this.setState({ state: values.name, StateId: values.id, statecode: values.code });
      SupplierService.getCities(values.id).then((response) => {
        this.setState({
          CityData: response.data, city: '', CityId: '',
        });
      });
    } else {
      this.setState({
        state: '', StateId: '', city: '', CityId: '', statecode: ''
      })
    }
  };

  handleCity = (value, values) => {
    if (values !== '' && typeof values === 'object' && values !== null) {
      this.setState({ city: values.name, CityId: values.id })
    } else {
      this.setState({ city: '', CityId: '' })
    }
  }

  validate(values) {
    let errors = {};
    // var chars = /^[A-Za-z ]+$/;
    var num = /^[0-9]+$/;
    if (this.state.companyname === '') {
      errors.companyname = "Company Name is required";
    }
    //  else if (!chars.test(this.state.companyname)) {
    //   errors.companyname = "Only Characters are allowed";
    // }
    if (this.state.contactname === '') {
      errors.contactname = "Contact Name is required";
    }
    // else if (!chars.test(this.state.contactname)) {
    //   errors.contactname = "Only Characters are allowed";
    // }

    if (this.state.contactnumber === '') {
      errors.contactnumber = "Contact Number is required";
    }
    if (!this.state.phonecode) {
      errors.phonecode = "Phone code is required";
    }
    // else if(this.state.country === "India"){
    //   if (!/^[7-8-9][0-9]{9}$/i.test(this.state.contactnumber)) {
    //     errors.contactnumber = "Contact Number should be 10 Numbers";
    //   }
    //   }

    if (!this.state.email) {
      errors.email = "Email is required";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(this.state.email)
    ) {
      errors.email = "Invalid email address";
    }
    if (this.state.address === '') {
      errors.address = "Address is required";
    }

    if (this.state.address2 === '') {
      errors.address2 = "Area/Place is required";
    }

    if (this.state.country === 'India' && this.state.registrationtype === "Registered") {
      if (this.state.gstin === '' || this.state.gstin === undefined) {
        errors.gstin = "GSTIN is required";
      } else if (!/^[A-Z0-9]{15}$/i.test(this.state.gstin)) {
        errors.gstin = "Invalid GST should be 15 Charactors EX: 22ABCDE1234F1Z5";
      } else if (
        !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9]{1}[Z]{1}[A-Z0-9]{1}/i.test(
          this.state.gstin
        )
      ) {
        errors.gstin = "Invalid Ex: 22ABCDE1234F1Z5";
      }
      // if(values.gstin.substring(0, 2) !== this.state.statecode){
      //   errors.gstin = `Invalid GSTIN for state ${this.state.state}`;
      // }
    }
    if (this.state.country === 'India') {
      if (this.state.zip === '' || this.state.zip === undefined) {
        errors.zip = "Zip is required";
      } else if (!num.test(this.state.zip)) {
        errors.zip = "Only Numbers allowed";
      } else if (!/^[0-9]{5,6}$/i.test(this.state.zip)) {
        errors.zip = "Should be 5 or 6 Numbers";
      }
    } else {
      if (this.state.zip === '') {
        errors.zip = "PO Box No. is required";
      }
    }
    if (this.state.CountryId === "") {
      errors.country = "Please Select Country";
    }
    if (this.state.StateId === "") {
      errors.state = "Please Select State";
    }
    if (this.state.CityId === "") {
      errors.city = "Please Select City";
    }

    if (this.state.currency === "") {
      errors.currency = "Please Select Currency";
    }

    return errors;
  }

  render() {
    // let countrypre = [this.state.countryprefix]

    let {
      id,
      companyname,
      contactname,
      contactnumber,
      email,
      address,
      address2,
      pan,
      gstin,
      zip,
      CountryData,
      StateData,
      CityData,
      country,
      state,
      city,
      statecode,
      alternatenumber,
      currency,
      currencylist,
      phonecode,
      taxtype,
      registrationtype
    } = this.state;


    return (
      <div>
        <Header />
        <Menu />
        <div className="content-wrapper">
          <div className="UI-container">
            <div className="UI-header">
              <Breadcrumb breadcrumbs={[{ name: "Home", path: "/masters" }, { name: "Suppliers", path: "/suppliers" }, { name: this.state.name, path: null }]} />
            </div>
            <div className="text-center text-danger">{this.state.error}</div>
            <div className="UI-form-card">
              <Formik
                initialValues={{
                  id,
                  companyname,
                  contactname,
                  contactnumber,
                  email,
                  address,
                  address2,
                  pan,
                  gstin,
                  zip,
                  CountryData,
                  StateData,
                  CityData,
                  country,
                  state,
                  city,
                  statecode,
                  alternatenumber,
                  currency,
                  currencylist,
                  phonecode,
                  taxtype,
                  registrationtype
                }}
                onSubmit={this.onSubmit}
                validateOnChange={false}
                validate={this.validate}
                enableReinitialize={true}
              >
                {({ setFieldValue, values, errors }) => (
                  <Form autoComplete="off">
                    <div className="form-row">
                      <fieldset hidden className="form-group col-md-6">
                        <label>Id</label>
                        <Field
                          className="form-control"
                          type="text"
                          name="id"
                          placeholder="Id"
                        />
                      </fieldset>

                      <fieldset className=" col-md-4">
                        <TextfieldComponent type="text" name="companyname" label="Company Name" value={this.state.companyname} onChange={(e) => this.setState({ companyname: e.target.value })} error={errors?.companyname} required
                        />
                      </fieldset>

                      <fieldset className=" col-md-4">
                        <TextfieldComponent type="text" name="contactname" label="Contact Name" value={this.state.contactname} onChange={(e) => this.setState({ contactname: e.target.value })} error={errors?.contactname} required />
                      </fieldset>

                      <fieldset className=" col-md-4">
                        <TextfieldComponent type="email" name="email" label="Email Id" value={this.state.email} onChange={(e) => this.setState({ email: e.target.value })} error={errors?.email} required />
                      </fieldset>

                      <fieldset className=" col-md-4">
                        <TextfieldComponent type="text" name="address" label="Address" value={this.state.address} onChange={(e) => this.setState({ address: e.target.value })} error={errors?.address} required />
                      </fieldset>

                      <fieldset className=" col-md-4">
                        <TextfieldComponent type="text" name="address2" label="Area/Place" value={this.state.address2} onChange={(e) => this.setState({ address2: e.target.value })} error={errors?.address2} required />
                      </fieldset>

                      <fieldset className=" col-md-4 m-0">
                        <AutoCompeteField id="country" name="country" options={CountryData} label="Select Country" value={this.state.country} labelKey={"name"} valueKey={"name"} onChange={this.ChangeCountry} error={errors?.country} required />
                      </fieldset>

                      <fieldset className=" col-md-4">
                        <AutoCompeteField id="state" name="state" options={StateData} label="Select State" value={this.state.state} labelKey={"name"} valueKey={"name"} onChange={this.ChangeState} error={errors?.state} required />
                      </fieldset>

                      <fieldset className=" col-md-4">
                        <AutoCompeteField id="city" name="city" options={CityData} label="Select City" value={this.state.city} labelKey={"name"} valueKey={"name"} onChange={this.handleCity} error={errors?.city} required />
                      </fieldset>
                      <fieldset className=" col-md-4">
                        <TextfieldComponent type="text" name="zip" label={this.state.country === "India" ? "Zip/Pincode" : "PO BOX No."} value={this.state.zip} onChange={(e) => this.setState({ zip: e.target.value })} error={errors?.zip} required />
                      </fieldset>

                      <fieldset className=" col-md-4">
                        <PhoneInput label="Contact Number" phonecode={this.state.phonecode} phonenumber={this.state.contactnumber} onChange={(phoneCode, newNumber) => this.setState({ contactnumber: newNumber.replace(/[^0-9]+/ig, ""), phonecode: phoneCode })} numbererror={errors?.contactnumber} codeerror={errors?.phonecode} required />
                      </fieldset>

                      <fieldset className=" col-md-4">
                        <PhoneInput label="Alternate Number" phonecode={this.state.alternatephonecode} phonenumber={this.state.alternatenumber} onChange={(phoneCode, newNumber) => this.setState({ alternatenumber: newNumber.replace(/[^0-9]+/ig, ""), alternatephonecode: phoneCode })} />
                      </fieldset>
                      <fieldset className=" col-md-4">
                        <AutoCompeteField id="currency" name="currency" options={currencylist} label="Select Currency" value={this.state.currency} labelKey={"currency"} valueKey={"currency"} onChange={this.handleCurrency} error={errors?.currency} required />
                      </fieldset>
                      {/* <fieldset className="form-group col-md-4 m-0">
                                <FormControl variant="standard" className="w-100">
                                  <InputLabel id="demo-simple-select-standard-label">Tax Type</InputLabel>
                                  <Select
                                    labelId="demo-simple-select-standard-label"
                                    id="demo-simple-select-standard"
                                    value={this.state.taxtype}
                                    onChange={this.handleTaxTypeChange}
                                    label="Tax Type"
                                  >
                                    {this.state.TaxtypeData.map((e,i)=>{
                                      return (
                                      <MenuItem value={e.type} key={i}>{e.type}</MenuItem>)
                                    })}
                                   
                                  </Select>
                                </FormControl>
                                </fieldset> */}

                      {/* <fieldset className="form-group col-md-12 m-0"/> */}
                      {/* <fieldset className="form-group col-md-3 mt-2">
                                    <FormControlLabel
                                      control={
                                        <Checkbox
                                          checked={this.state.registrationtype}
                                          onChange={() =>
                                            this.setState({
                                              registrationtype: !this.state.registrationtype,
                                            })
                                          }
                                          name="ordertype"
                                          color="primary"
                                          // disabled={this.state.orderfrom === 1}
                                        />
                                      }
                                      label="Tax Registered?"
                                    />
                                  </fieldset> */}

                      {this.state.country === "India" ?
                        <fieldset className=" col-md-4 m-0">
                          <SelectField label="Registration Type" lableKey={"type"} list={this.state.Registrationtypes} lableValue={"type"} value={this.state.registrationtype} onChange={this.handleRegistrationTypeChange} />
                        </fieldset>
                        : ''}

                      <fieldset className=" col-md-4">
                        <TextfieldComponent type="text" name="gstin" label={this.state.country === "India" ? "GSTIN" : "GSTIN / VAT No."} value={this.state.gstin} onChange={(e) => this.setState({ gstin: e.target.value?.trim().toUpperCase(), error: '', validgstin: false })} error={errors?.gstin} required />
                      </fieldset>
                      {this.state.country === "India" ?
                        <fieldset className=" col-md-4">
                          <TextfieldComponent type="text" name="pan" label="PAN" value={this.state.pan} onChange={(e) => this.setState({ pan: e.target.value })} error={errors?.pan} required />
                        </fieldset> : ''}


                    </div>

                    {accounts === "YES" && !this.state.ledgerid && <>
                      <div className="">
                        <FormGroup row>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={this.state.createledger}
                                onChange={(e) => this.setState({ createledger: e.target.checked })}
                                name="createledger"
                                color="primary"
                              />
                            }
                            label="Create Ledger"
                          />
                        </FormGroup>
                      </div>
                      {this.state.createledger && <div>
                        <Autocomplete
                          id="currency"
                          name="currency"
                          options={this.state.types}
                          getOptionLabel={(option) => option}
                          // value={taxtype}
                          onChange={(value, values) => this.setState({ type: values })}
                          renderInput={(params) => (
                            <div ref={params.InputProps.ref} style={{ position: 'relative', width: '200px' }}>
                              <input
                                type="text"
                                {...params.inputProps}
                                className="UI-input"
                                placeholder="Select Ledger Type"
                                value={this.state.type}
                                style={{
                                  width: '100%',
                                  // paddingRight: currency && currency !== basecurrency ? '30px' : undefined
                                }}
                              />
                            </div>
                          )}
                        />
                      </div>}
                    </>}
                    <div className="form-row">
                      {/* <fieldset className="form-group col-md-4">
                      {rendercountry}
                        <ErrorMessage name="country" component="div" className="text-danger float-sm-right" />
                      </fieldset>

                      <fieldset className="form-group col-md-4">
                       {renderstate}
                        <ErrorMessage name="state" component="div" className="text-danger float-sm-right" />
                      </fieldset>

                      <fieldset className="form-group col-md-4">
                        {rendercity}
                        <ErrorMessage name="city" component="div" className="text-danger float-sm-right" />
                      </fieldset> */}

                      <fieldset className="form-group col-md-12" />
                      {/* <fieldset className="form-group col-md-4"/> */}
                      <fieldset className="form-group col-md-12 tw-flex tw-justify-end">
                        {this.state.loader === true ? (
                          <button className="UI-btn UI-btn-primary" disabled>
                            <Spinner animation="border" size="sm" />
                            &nbsp;{"Saving"}
                          </button>
                        ) : (
                          <button className="UI-btn UI-btn-primary" type="submit">Save</button>
                        )}
                        {/* </fieldset>
                    <fieldset className="form-group col-md-1"> */}
                        <Link
                          as="button"
                          className="UI-btn UI-btn-outline ml-1 "
                          to={{ pathname: "/suppliers" }}
                          state={{ message: "" }}
                        >Close
                        </Link>
                      </fieldset>
                    </div>

                    {/* <fieldset className="form-group col-md-12"/>
                   <Link as="button" type="submit" className="btn btn-success" to={{pathname: '/ledgers' }} state ={ {message:this.state.message}}}>Save</Link> 
                     */}
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>

        {/* /.card-header */}
        {/* form start */}

        <Footer />
      </div>
    );
  }
}
export default withRouter(NewSupplier);
